import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover, Button } from 'react-bootstrap';
import Translation from "../../../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import Icons from "../../../../../icon";
import {
    ORFButton
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions,
    ORFCheckbox
} from '../../../../../common/forms/order-request-form.component';
import { wirelessChangeVendorActions } from "../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer";
import { createRequestActions } from "../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "../../../../../../store/external/request-reducer/request-log.reducer";
import ChangeVendorBusinessFormA from './wireless-change-vendor-business-form.component';
import { CheckBox } from '../../../../../common/custom-form/checkbox.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { Milestone } from '../../../../../common/milestone/milestone.component';
import { Loading } from '../../../../../common/loading';
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { MAX_LENGTH, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class MobileChangeVendorForm extends Component {
    constructor(props) {
        super(props);
        this.state={
            isSubscriptionForm:true,
            isBusinessForm:false,
            isDevice: true,
            error: false,
            isLoading: true,          
            activeIndex:0,
            milestones:[
                "subscription",
                "business_justification"
            ],
            isToggle: true
        }
        this.SearchSuggestions = React.createRef();
        this.PhoneAccessoryCheckbox = React.createRef();
    }

    componentWillUnmount() {
        this.props.resetWirelessChangeVendorForm();
        this.props.resetRequestData();
    }

    async componentDidMount(){
        const { updateDataList, isUpdateRequest, subscriptionList, takeActionCircuitCode, takeActionCircuitId, isRequestOnBehalf } = this.props.createRequest;
        const { onUpdateAutoPopulate, fetchSubscriptionByValue, onSubscriptionSelect, onROBSubscripitionAutoSelect, wirelessChangeVendorFormA, requestDetail } = this.props

        this.props.resetWirelessChangeVendorForm();
        this.props.getChangeVendorFormData();

        if (isUpdateRequest) {
            const selectedItem = requestDetail.requestData.Order;
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            if(selectedItem?.IsRequestedInBehalf){                             
                if (this.SearchSuggestions.current) {
                    this.SearchSuggestions.current.onChange(null, { newValue: currentCircuitCode });
                }
                await onROBSubscripitionAutoSelect(currentCircuitCode, selectedItem.EndUserId)
                await onUpdateAutoPopulate(updateDataList, selectedItem?.IsRequestedInBehalf);
            }
            else {
                const updatedSubscriptionList = await fetchSubscriptionByValue(currentCircuitCode);

                await onSubscriptionSelect(currentCircuitCode, "CircuitCode", updatedSubscriptionList);
                await onUpdateAutoPopulate(updateDataList);
                this.SearchSuggestions.current.onChange(null, {newValue: currentCircuitCode});

                this.setState({ isLoading: false });
            }
        } else{
            if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
                var circuitCodePropName = 'CircuitCode';
                var listOfSubscription = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

                onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, listOfSubscription, null, takeActionCircuitId);
            }
            else {
                onSubscriptionSelect('');
            }
        }
    }

    nextAction = () => {

        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;
               
        if (isSubscriptionForm) {
            this.setState({
                isSubscriptionForm:false,
                isBusinessForm:true,
                activeIndex: 1              
            });          

            disableROBCheckbox(true);
        } 
    }

    prevAction = () => {

        const { isBusinessForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;
       
        if (isBusinessForm) {
            this.setState({
                isSubscriptionForm: true,               
                isBusinessForm: false,
                activeIndex: 0
            });

            disableROBCheckbox(false);
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    displayForm = () => {
        const { isBusinessForm } = this.state;
      
        let form;

       if(isBusinessForm) {
            form=<ChangeVendorBusinessFormA hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} onClickCancel={this.onClickCancel} prevAction={this.prevAction}/>
       }

        return (form);
    }

    checkBoxValue = (value) =>{
        const { onPhoneAccessoryTick } = this.props;
        onPhoneAccessoryTick(value);
        this.setState({isToggle: value})
    }

    render() {
        const {
            //form
            wirelessChangeVendorFormA
            //reducer action
            , setRequestorAddress
            , onSubscriptionSelect
            , fetchSubscriptionByValue
            , onVendorSelect
            , onPlanSelect
            , onOtherPlanSelect
            , onOrderSelect
            , onServiceTypeSelect
            , onCircuitTypeSelect
            , onAccessorySelect
            , onCountrySelect
            , onAddressSelect

            , handleVendorSearch
            , loadMoreVendor
            , handleCircuitTypeSearch
            , loadMoreCircuitType
            , handleMobServiceTypeSearch
            , loadMoreMobServiceType
            , handlePlanTypeSearch
            , loadMorePlanType
        } = this.props;

        const { subscriptionList, takeActionCircuitCode, isUpdateRequest, isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        const { preferredVendorOptions
            , userLocation
            , accountOptions
            , planOptions
            , otherPlanOptions
            , simOptions
            , orderOptions
            , deviceOptions
            , countryOptions
            , addressOptions
            , businessCaseOptions
            , planDetails
            , vendorDetails
            , serviceTypeDetail
            , showDeviceOptions
            , deviceAccessories 
            , formSubmitted
            , circuitTypeOptions
            , subscription
            , isResetLoading

            , isCountryLoading
            , hasMoreCountry

            , isAddressLoading
            , hasMoreAddress

            , isVendorLoading
            , hasMoreVendor
            , vendorOptions

            , isCircuitTypeLoading
            , hasMoreCircuitType

            , isMobServiceTypeLoading
            , hasMoreMobServiceType
            , isPlanTypeLoading
            , hasMorePlanType
            } = this.props.wirelessChangeVendorRequest;

        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";
        let disable = wirelessChangeVendorFormA.circuitId == 0
            || wirelessChangeVendorFormA.newVendorId == 0
            || wirelessChangeVendorFormA.equipmentCatalogId == 0
            //|| wirelessChangeVendorFormA.orderOptionId == 0
            //|| wirelessChangeVendorFormA.newAccountId == 0
            || wirelessChangeVendorFormA.newPlanId == 0
            || wirelessChangeVendorFormA.planDetailsModel.length == 0
            //|| wirelessChangeVendorFormA.newSimTypeId == 0
            || wirelessChangeVendorFormA.businessJustification == ''
            || wirelessChangeVendorFormA.countryCode == ''
            || wirelessChangeVendorFormA.locationId == ''
            || wirelessChangeVendorFormA.busJustiCodeDetailId == 0
            || formSubmitted;
        let nextDisable = !wirelessChangeVendorFormA.newVendorId 
            || !wirelessChangeVendorFormA.circuitTypeId 
            || !wirelessChangeVendorFormA.circuitId 
            || !wirelessChangeVendorFormA.locationId 
            || !wirelessChangeVendorFormA.countryCode
            || wirelessChangeVendorFormA.equipmentCatalogId == 0
            || wirelessChangeVendorFormA.newPlanId == 0
            || (isRequestOnBehalf && !(requestOnBehalfData && requestOnBehalfData.EmployeeId > 0));
        let showPreferredAddress = wirelessChangeVendorFormA.locationId.toString() === "-1";
        if (showDeviceOptions) {
            disable = disable || wirelessChangeVendorFormA.equipmentCatalogId == 0;
        }

        if (showPreferredAddress) {
            nextDisable = nextDisable || wirelessChangeVendorFormA.otherDeliveryAddress === '';
        }

        const accessoryCost = wirelessChangeVendorFormA.accessoryDetailsModel.length > 0 ?
            wirelessChangeVendorFormA.accessoryDetailsModel.reduce((accum, item) => accum + item.OrderCost, 0) : 0;

        const totalOrderCost = wirelessChangeVendorFormA.newPlanId ? (wirelessChangeVendorFormA.planDetailsModel.reduce((accum, item) => accum + item.ComponentCost, 0)) : 0;

        const formattedtotalOrderCost = parseFloat(totalOrderCost).toFixed(2);

        const sortedPlanComponentList = wirelessChangeVendorFormA.planComponentList.map(item => {
            return {
                ...item,
                dataItem: item.dataItem.slice().sort((a, b) => (a.ComponentCost - b.ComponentCost))
            }
        });

        return (
            <div className="portin-subscription-container" >
                 {
                    (this.state.milestones && this.state.milestones.length > 0) &&
                    <>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Milestone milestones={this.state.milestones} activeIndex={this.state.activeIndex}/>
                            </Col>
                        </Row>
                    </>
                }                      
                {this.state.isSubscriptionForm ?
                <>                        
                    <Form method="post" role="form"
                        model="wirelessChangeVendorFormA"
                        onSubmit={this.nextAction}
                    >                                
                            <Row className='search-suggestion'>
                                <Col xs={12} md={12} lg={12} className='required'>{
                              !isResetLoading && <SearchSuggestions
                              ref={this.SearchSuggestions}
                              value={wirelessChangeVendorFormA.circuitCode}
                              label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                              placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                              propDisplay={'CircuitCode'} 
                              options={subscriptionList.length > 0 ? subscriptionList : ''}
                              onChangeAction={onSubscriptionSelect}
                              searchAction={fetchSubscriptionByValue}
                              defaultValue={takeActionCircuitCode}
                              maxLength={MAX_LENGTH.limit_100}
                              errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                              haveError={this.haveError}

                          />
                        } 
                        </Col>
                        {(wirelessChangeVendorFormA.circuitCode !== '' && wirelessChangeVendorFormA.circuitCode !== null ) &&
                            <div className="pb-15-pl-30">
                                <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName? circuitStatusName : "N/A" } </span> <span>| </span>
                                {subscription?.VendorName != null ? subscription.VendorName : "N/A"} <span>| </span>
                                {subscription?.PlanName? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                {subscription?.DeviceName != null ? subscription.DeviceName : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>
                    <span className='text-field-title'>CHANGE TO NEW VENDOR</span>
                            <Row className="margin-bottom-20">
                            <div className='use-request-container'>
                                 <span onClick={setRequestorAddress} className="requestor-address-link">Use Requestor Address</span>
                            </div>
                                <Col xs={12} md={12} lg={12} className='required' >
                                    <CustomSearchableDropdownWrapper
                                       // requiredField
                                        label={`${this.toLocaleLanguage('country')}`}
                                        options={countryOptions} 
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                        fieldProp='.countryCode'
                                        selected={wirelessChangeVendorFormA.countryCode}    
                                        onChange={(Value) => onCountrySelect('wirelessChangeVendorFormA.countryCode', Value)}
                                        optionLabelKey={{
                                            Key: 'Key',
                                            Value: 'Value'
                                        }}
                                        maxLength={MAX_LENGTH.limit_100}
                                        isNullable={true}
                                        onSearchChange={this.props.handleCountrySearch}
                                        onLoadMore={(e) => this.props.loadMoreCountry(e)}
                                        isLoading={isCountryLoading}
                                        hasMore={hasMoreCountry}
                                    />
                        </Col>
                    </Row>

                    <Row>                       
                                <Col xs={12} md={12} lg={12} className='address-container required'>     

                                    <CustomSearchableDropdownWrapper                                        
                                        label={`${this.toLocaleLanguage('delivery_address')}`}
                                        options={addressOptions}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                        fieldProp='wirelessChangeVendorFormA.locationId'
                                        selected={wirelessChangeVendorFormA.locationId}
                                        onChange={(Value) => onAddressSelect('wirelessChangeVendorFormA.locationId', Value)}
                                        optionLabelKey={{
                                            Key: 'Key',
                                            Value: 'Value'
                                        }}
                                        maxLength={MAX_LENGTH.limit_500}

                                        onSearchChange={this.props.handleAddressSearch}
                                        onLoadMore={this.props.loadMoreAddress}
                                        isLoading={isAddressLoading}
                                        hasMore={hasMoreAddress}
                                    />
                             {
                                (wirelessChangeVendorFormA.deliveryAddress !== '' && wirelessChangeVendorFormA.locationId !== '') &&
                                        <div className="request-details-container custom-details">
                                                {wirelessChangeVendorFormA.deliveryAddress}
                                        </div>  
                            }
                        </Col>
                    </Row>
                            {showPreferredAddress &&
                                <Row>
                                    <Col xs={12} md={12} lg={12} className='required'>
                                        <TextArea
                                            label={`${this.toLocaleLanguage('preferred_delivery_address')}`}
                                            placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                            fieldProp='.otherDeliveryAddress'
                                            value={wirelessChangeVendorFormA.otherDeliveryAddress}
                                            disabled={wirelessChangeVendorFormA.circuitId == 0}
                                            maxLength={MAX_LENGTH.limit_255}
                                        />
                                    </Col>
                                </Row>
                            }


                    <div>                       
                        <Row>
                                    <Col xs={12} md={12} lg={12} className='address-container required'>
                                <CustomSearchableDropdownWrapper                                        
                                    label={`${this.toLocaleLanguage('new_vendor')}`}
                                    options={vendorOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.newVendorId'
                                    selected={wirelessChangeVendorFormA.newVendorId}
                                    onChange={(Value) => onVendorSelect('wirelessChangeVendorFormA.newVendorId', Value)}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_100}

                                    onSearchChange={handleVendorSearch}
                                    onLoadMore={loadMoreVendor}
                                    isLoading={isVendorLoading}
                                    hasMore={hasMoreVendor}
                                />
                            </Col>
                        </Row>
                        <Row>
                                    <Col xs={12} md={12} lg={12} className='address-container required'>
                                <CustomSearchableDropdownWrapper                                        
                                    label={`${this.toLocaleLanguage('circuit_type')}`}
                                    options={circuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.circuitTypeId'
                                    selected={wirelessChangeVendorFormA.circuitTypeId}
                                    onChange={(Value) => onCircuitTypeSelect(wirelessChangeVendorFormA.circuitTypeId, Value)}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_100}

                                    onSearchChange={handleCircuitTypeSearch}
                                    onLoadMore={loadMoreCircuitType}
                                    isLoading={isCircuitTypeLoading}
                                    hasMore={hasMoreCircuitType}
                                />
                            </Col>
                        </Row>
                        <Row>
                                    <Col className='address-container service-type-container required' xs={12} md={12} lg={12}>
                                <CustomSearchableDropdownWrapper                                        
                                    label={`${this.toLocaleLanguage('mobile_service_type')}`}
                                    options={deviceOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.equipmentCatalogId'
                                    selected={wirelessChangeVendorFormA.equipmentCatalogId}
                                    onChange={(Value) => onServiceTypeSelect(wirelessChangeVendorFormA.equipmentCatalogId, Value)}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value' 
                                    }}
                                    maxLength={MAX_LENGTH.limit_100}

                                    onSearchChange={handleMobServiceTypeSearch}
                                    onLoadMore={loadMoreMobServiceType}
                                    isLoading={isMobServiceTypeLoading}
                                    hasMore={hasMoreMobServiceType}
                                />
                                    </Col>
                        </Row>
                                {wirelessChangeVendorFormA.circuitTypeId !== '' && wirelessChangeVendorFormA.circuitTypeId !== "2" && wirelessChangeVendorFormA.circuitTypeId !== 2 ? (
                                    <div className="checkbox-container">
                                        <ControlCheckBox
                                            classWrapper="custom-checkbox-wrapper mb-3"
                                            label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                                            model="wirelessChangeVendorFormA.isPhoneAccessory"
                                            checked={wirelessChangeVendorFormA.isPhoneAccessory} />
                                    </div>
                                ) : null}
                        <Row>
                            <Col xs={12} md={12} lg={12} className='address-container select_plan_container required'>
                              
                                <CustomSearchableDropdownWrapper                                        
                                    label={`${this.toLocaleLanguage('plan')}`}
                                    options={planOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.newPlanId'
                                    selected={wirelessChangeVendorFormA.newPlanId}
                                    onChange={(Value) => onPlanSelect(wirelessChangeVendorFormA.newPlanId, Value)}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_100}
                                    isNullable={true}
                                    onSearchChange={handlePlanTypeSearch}
                                    onLoadMore={loadMorePlanType}
                                    isLoading={isPlanTypeLoading}
                                    hasMore={hasMorePlanType}
                                />
                            </Col>
                        </Row>

                                {wirelessChangeVendorFormA.newPlanId ?
                                    <TableWithButton
                                        classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                                        datatable={sortedPlanComponentList}
                                        haveExternalDeleteBtn={false}
                                        haveCheckBox={true}

                                    /> : null
                                }

                        <div className="price-plan-total-cost-container">
                            <div className="price-plan-header">
                                <span><Translation translationKey="total_order_cost" /></span>
                            </div>
                            <div className="price-plan-total">
                                <span>{vendorDetails.Currency}</span>
                                <span>{formattedtotalOrderCost}</span>
                            </div>
                        </div>
                    </div>

                
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={nextDisable}
                                />
                            </div>
                        </div>
                    </div>                  
                </Form>
                </>
                  :
                  this.displayForm()  
                }
            </div>
        );
    }
};


export default connect(
    state => {
        const { wirelessChangeVendorRequest, createRequest, translation, requestDetail } = state;
        const { wirelessChangeVendorFormA } = state.form;
        return {
            wirelessChangeVendorRequest
            , wirelessChangeVendorFormA
            , createRequest
            , requestDetail
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessChangeVendorActions, createRequestActions, requestLogActions),
            dispatch
        )
)(MobileChangeVendorForm);
